import {getUniqueId} from "../../_shared/helper";

export const anonymotizeValue = (value: any) => {
  return {...value, id: getUniqueId()};
};
